export function removeLeadingCharacter(char: string, str: string): string {
  if (str.startsWith(char)) {
    return removeLeadingCharacter(char, str.slice(1));
  }
  return str;
}
